<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<ContentTitle title="Documents" />

			<div class="mh-middle-container">
				<div class="mh-time-entries-top mh-time-off">
					<Documents path="branch/" :hideActions="true" :hideContextMenu="true" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import Documents from "./partials/Documents"

	export default {
		name: 'DocumentsContent',
		components: {
			ContentTitle,
			Documents
		}
	}
</script>

<style scoped>
	.mh-middle-inner {
		height: 100% !important;
	}

	.mh-middle-container {
		height: 100% !important;
	}
</style>